export const signInModel = ({
                                email,
                                password,
                            } = {}) => ({
    email,
    password,
});